export default __webpack_public_path__ + "static/media/T750_RoHS.8687db21.pdf";